<template>
  <v-container class="affiliate-statistics-and-payments-tabs-container">
    <v-tabs
      v-model="activeTab"
      class="affiliate-statistics-and-payments-tabs"
      slider-size="4"
      @change="handleTabChange"
    >
      <v-tab
        v-for="(tab, index) in tabs"
        :key="index"
      >
        <div class="affiliate-statistics-and-payments-tabs-tab-name">
          <div class="affiliate-statistics-and-payments-tabs-tab-name-text">
            {{ $t(`affiliateProgram.links.${tab}`) }}
          </div>
          <div class="affiliate-statistics-and-payments-tabs-tab-name-underline" />
        </div>
      </v-tab>

      <!--   STATISTICS   -->
      <v-tab-item>
        <affiliate-statistics-tab />
      </v-tab-item>

      <!--   PAYMENTS   -->
      <v-tab-item>
        <affiliate-payments-tab />
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import AffiliateStatisticsTab from '@/components/affiliate/AffiliateStatisticsTab.vue'
import AffiliatePaymentsTab from '@/components/affiliate/AffiliatePaymentsTab.vue'
import { mapActions } from 'vuex'

export default {
  name: 'AffiliateStatisticsAndPaymentsTabs',
  components: {
    AffiliateStatisticsTab,
    AffiliatePaymentsTab
  },
  data() {
    return {
      activeTab: 0,
      tabs: ['statistics', 'payments']
    };
  },
  methods: {
    ...mapActions({
      loadStatistics: 'affiliate/loadStatistics',
      loadPayments: 'affiliate/loadPayments',
    }),

    handleTabChange(val) {
      const isStatisticsTab = val === 0
      const isPaymentsTab = val === 1

      if (isStatisticsTab) {
        this.loadStatistics()
      }

      if (isPaymentsTab) {
        this.loadPayments()
      }
    }
  }
};
</script>

<style lang="scss">
.affiliate-statistics-and-payments-tabs .v-tabs-bar {
  margin-bottom: 24px;
}

.affiliate-statistics-and-payments-tabs-tab-name {
  text-transform: none;
  letter-spacing: 0;
  max-width: max-content;
}

.affiliate-statistics-and-payments-tabs-container {
  padding: 0;
  margin-top: 48px;

  .affiliate-statistics-and-payments-tabs-tab-name-text {
    margin-bottom: 12px;
  }

  .affiliate-statistics-and-payments-tabs {
    .v-tab:hover::before {
      opacity: 0;
    }
    .v-tab:hover div {
      color: var(--v-tab-nav-foreground-active-base);
    }

    .v-slide-group__content {
      column-gap: 20px;
    }

    .v-tabs-slider-wrapper {
      display: none;
    }

    .v-tabs-bar .v-tab:not(.v-tab--active),
    .v-tab {
      font-feature-settings: 'clig' off, 'liga' off;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 32px;
      padding: 0;
    }

    .v-tabs-bar .v-tab:not(.v-tab--active) {
      color: var(--v-tab-nav-foreground-default-base);

      .affiliate-statistics-and-payments-tabs-tab-name-underline {
        height: 4px;
      }
    }

    .v-tab.v-tab--active {
      color: var(--v-tab-nav-foreground-active-base);

      .affiliate-statistics-and-payments-tabs-tab-name-underline {
        width: 100%;
        border-radius: 1px;
        height: 4px;
        background: var(--v-tab-nav-border-active-base);
      }
    }
  }
}

.affiliate-statistics-and-payments-tabs {
  .v-data-table > .v-data-table__wrapper > table > thead > tr {
    height: 40px;
    min-height: unset;
    max-height: 40px;
  }

  .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    color: var(--v-text-secondary-base);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.1px;
    height: 44px;
    min-height: unset;
    max-height: 44px;
  }

  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    color: var(--v-text-primary-base);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    height: 40px;
    min-height: unset;
    max-height: 40px;
    line-break: anywhere;
  }

  .v-data-table > .v-data-table__wrapper > table > thead > tr > th:last-child,
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td:last-child {
    padding: 0!important;
  }

  .v-data-table > .v-data-table__wrapper > table > tbody > tr.v-data-table__empty-wrapper > td {
    height: 68px;
    min-height: unset;
    max-height: unset;
    color: var(--v-text-primary-base);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
}
</style>
